import axios from 'axios';

let instance = axios.create({
  baseURL: process.env.REACT_APP_SMARTORDER_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  },
});

// 응답 인터셉터 추가
instance.interceptors.response.use(
  function (response) {
    // 응답 데이터를 가공
    return response;
  },
  function (error) {
    // 오류 응답을 처리
    if (error.response && error.response.data) {
      if (error.response.data.errorCode) {
        return Promise.reject(error);
      } else {
        // 서버에러가 아니고 에러 메시지가 있다면 전달 받은 에러 메시지
        throw new Error(error.response.data.message);
        //return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

const api = {
  // 상점 정보 조회
  getStore(companyId, storeCode, languageCode) {
    return instance.get(`/companies/${companyId}/stores/${storeCode}?langCode=${languageCode}`);
  },
  getLiffId(companyId, storeCode) {
    return instance.get(`/companies/${companyId}/stores/${storeCode}/liff-id`);
  },
  // 주문 저장 후 주문번호 및 PG 인증 데이터 반환
  addOrder(orderData) {
    return instance.post('/order', JSON.stringify(orderData));
  },
  // 포인트 주문 결제
  payOrderByPointOnly(orderData) {
    return instance.post(`/sales/point`, JSON.stringify(orderData));
  },
  // 주문 조회
  getSale(companyId, storeCode, orderId, languageCode) {
    return instance.get(`/companies/${companyId}/stores/${storeCode}/sales/${orderId}?langCode=${languageCode}`);
  },
  // 주문 상태 조회
  getOrderState(companyId, storeCode, orderId) {
    return instance.get(`/companies/${companyId}/stores/${storeCode}/sales/${orderId}/status`);
  },
  // 주문 매장 리스트 조회
  getOrderStoresByUser(encryptedId) {
    return instance.get(`/users/${encryptedId}/order-stores`);
  },
  // 회원 포인트 조회
  getUserPointByPhoneNumber(companyId, storeCode, phoneNumber) {
    return instance.get(`/companies/${companyId}/stores/${storeCode}/users/${phoneNumber}`);
  },
  getLiteOrder(companyId, storeCode, orderId, languageCode) {
    return instance.get(
      `/companies/${companyId}/stores/${storeCode}/lite-orders/${encodeURIComponent(orderId)}?langCode=${languageCode}`,
    );
  },
  // QR주문 임시 저장
  addQrOrder(orderData) {
    return instance.post('/qr-order', JSON.stringify(orderData));
  },
  // 이지웰페이 결제 준비
  readyEzwelPay(orderData) {
    return instance.post('/sales/ezwelpay/ready', JSON.stringify(orderData));
  },
  // 쿠폰 조회
  getCoupon(companyId, storeCode, couponId, couponItemCode) {
    return instance.get(`/companies/${companyId}/stores/${storeCode}/coupons/${couponId}?itemCode=${couponItemCode}`);
  },
};

export default api;
